import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";

// import { AuthProvider } from "./context/AuthContext";
// import ReducerProvider from "./store/ReducerProvider";
import {persistor, store} from "./store/store";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  // <AuthProvider>
   
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}> 
      <App />
      </PersistGate>
    </Provider>
    

   
  // </AuthProvider>
);

// If you want to start measuring performance in your app, pass a function

// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
